<div class="flexed-sub">
  <div class="sub-item-25">
    <mat-card>
      <mat-card-header>{{
        "num-of-municipalities" | translate
        }}</mat-card-header>
      <mat-card-content>{{ model.municipalities }}</mat-card-content>
    </mat-card>
  </div>

  <div class="sub-item-25">
    <mat-card>
      <mat-card-header>
        {{ "num-of-periods" | translate }}
      </mat-card-header>
      <mat-card-content> {{ model.periods }}</mat-card-content>
    </mat-card>
  </div>
  <div class="sub-item-25">
    <mat-card>
      <mat-card-header>
        {{ "num-of-buildings" | translate }}
      </mat-card-header>
      <mat-card-content> {{ model.buildings }}</mat-card-content>
    </mat-card>
  </div>
  <div class="sub-item-25" *ngIf="isAdministrator">
    <mat-card>
      <mat-card-header>
        {{ "num-of-users" | translate }}
      </mat-card-header>
      <mat-card-content>{{ model.users }}</mat-card-content>
    </mat-card>
  </div>
</div>
<mat-divider></mat-divider>
<div class="flexed-sub">
  <div class="sub-item-30">
    <app-line-chart></app-line-chart>
  </div>
  <div class="sub-item-30">
    <app-pie-chart></app-pie-chart>
  </div>
  <div class="sub-item-30">
    <app-donut-chart></app-donut-chart>
  </div>
</div>
